import { createTheme } from 'components/mui';
import { useDispatch, useSelector } from 'react-redux';
import muiLightMode from 'styles/muiTheme/muiLightMode.js';
import muiDarkMode from 'styles/muiTheme/muiDarkMode.js';
import { toggleMode } from 'redux/preferTheme/preferThemeSlice';
import { THEME_DARK_MODE, THEME_LIGHT_MODE } from 'constants/theme.js';

/**
 * @function useTheme
 * @returns {object}
 */
function useTheme() {
	let _themeMode = null;
	let muiTheme = null;

	const dispatch = useDispatch();
	const _muiLightMode = muiLightMode;
	const _muiDarkMode = muiDarkMode;

	const _preferTheme = JSON.parse(localStorage.getItem('preferTheme'));

	if (_preferTheme === null) {
		_themeMode = String(THEME_LIGHT_MODE);
	} else {
		_themeMode = String(_preferTheme);
	}

	dispatch(toggleMode(_themeMode));

	const themeMode = useSelector((state) => state.preferTheme.mode);

	if (themeMode === THEME_LIGHT_MODE) {
		muiTheme = createTheme({ ..._muiLightMode });
	} else if (themeMode === THEME_DARK_MODE) {
		muiTheme = createTheme({ ..._muiDarkMode });
	}

	return { muiTheme, themeMode };
}

export default useTheme;
